<template>
  <div class="store-group-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'store_group_list'}" class="float-left mr-1 main-link">{{$t('store_group.store_group')}}</router-link> / {{$t('store.store_profile')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('common.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('store_group.basic_information') }}</strong>
            </div>
            <b-form class="row" v-if="item != null">
              <b-col cols="12">
                <b-form-group v-bind:label="$t('store_group.store_group_name')" :label-cols="2" :horizontal="true">
                  <div class="row">
                    <div v-for="lang in $store.getters.languages" class="group_name_input col-sm-6">
                      <b-form-input
                        class="form-control border-radius-4px"
                        v-model="item.name[lang]"
                        v-bind:placeholder="$t('common.text_' + lang)"
                        :name="`name[${lang}]`"
                        :state="nameState(lang)"
                        :aria-describedby="'name-feedback' + lang" />
                      <b-form-invalid-feedback :id="'name-feedback' + lang">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="search-form">


                  <div class="col-sm-10">
                    <b-col sm="6" style="float: left;">
                      <b-input-group>
                        <select-dropdown  v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="field" prefix="store">
                        </select-dropdown>
                        <input type="text" class="form-control " v-model="key" v-on:keydown.enter="getOutletList"/>
                        <div class="input-group-append">
                          <b-input-group-append>
                            <b-btn @click="getOutletList()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                          </b-input-group-append>
                        </div>
                      </b-input-group>
                    </b-col>

                    <b-col sm="6" style="padding-left: 15px; padding-right: 0">
                      <b-col sm="6">
                          <b-input-group v-bind:prepend="$t('store.status')">
                            <b-form-select v-model="filter.status" v-bind:value="filter.status" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('store.active')">
                            </b-form-select>
                          </b-input-group>
                      </b-col>
                      <b-col sm="6" v-if="uuid !== 'create'">
                        <button type="button" class="btn bg-main border-radius-4px pull-right" v-on:click="addStoreGroup()"><i class="fa fa-plus"> </i>{{$t('store.add_new_store')}}</button>
                      </b-col>
                    </b-col>
                  </div>

              </b-col>

              <b-col cols="12">
                <div class="table-responsive outlet-data">
                  <table class="table table-striped table-hover table-sm header-pointer table-bordered">
                    <thead>
                    <tr>
                      <th scope="col" v-if="uuid === 'create'">
                        <div class="custom-control custom-control-inline">
                          <input id="checkbox1" type="checkbox" class="custom-control-input" @change="selectAll" v-model="allSelected">
                          <label for="checkbox1" class="custom-control-label"></label>
                        </div>
                      </th>
                      <th scope="col">{{$t('store.status')}}</th>
                      <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)">
                        <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                        <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                        <span v-if="item.label != null">{{$t('store.'+item.label)}}</span>
                        <span v-if="item.label == null">{{$t('store.'+item.name)}}</span>
                      </th>
                      <th scope="col" v-if="uuid !== 'create'">{{$t('common.action')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="dataTable.items.length == 0">
                      <td class="text-center" :colspan="dataTable.fields.length + 2">
                        {{$t('message.no_data')}}
                      </td>
                    </tr>
                    <tr v-for="item in dataTable.items" :key="item.id">
                      <td scope="row" v-if="uuid === 'create'">
                        <div class="custom-control custom-control-inline">
                          <input :id="'checkbox_item_' + item.id" type="checkbox" class="custom-control-input" v-model="uuids" @change="updateAllSeleted" :value="item.uuid">
                          <label :for="'checkbox_item_' + item.id" class="custom-control-label"></label>
                        </div>
                      </td>
                      <td scope="row">
                        <span v-if="item.active == 1">{{$t('common.active')}}</span>
                        <span v-if="item.active != 1">{{$t('common.inactive')}}</span>
                      </td>
                      <td scope="row" v-for="field in dataTable.fields" :key="field.id">
                        <span v-if="field.render != null" v-html="field.render(item[field.name == 'outlet_collection' ? 'quote_time' : field.name == 'outlet_delivery' ? 'quote_time' : field.name], item)"></span>
                        <span v-if="field.render == null">
                          {{item[field.name]}}
                        </span>
                      </td>
                      <td scope="row" v-if="uuid !== 'create'">
                        <b-button size="sm" variant="primary" v-on:click="removeStoreGroup(item.uuid)">
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <b-row>
                  <b-col>
                    <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                  </b-col>
                  <b-col class="text-left">
                    {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                  </b-col>
                  <b-col col lg="1">
                    <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                  </b-col>
                </b-row>
              </b-col>

            </b-form>
            <div slot="footer">
              <router-link :to="{ name: 'store_group_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
              <div class="btn-save">
                <span style="vertical-align: middle; padding: 15px; line-height: 30px" v-if="uuid !== 'create'">{{ totalStoresIncluded }} {{$t('store_group.stores_included')}}</span>
                <button v-if="uuid !== 'create'" type="button" class="btn bg-main border-radius-4px pull-right pl-3 pr-3" v-on:click="saveStoreGroup()" :disabled="checkSubmit()" > {{$t('common.save')}}</button>
                <button v-else type="button" class="btn bg-main border-radius-4px pull-right pl-3 pr-3" v-on:click="saveStoreGroup()" :disabled="checkSubmit()" > {{$t('common.save')}}({{uuids.length}})</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import {validationMixin} from 'vuelidate'
  import {required, minLength, maxLength, between, integer, minValue, email, decimal, or, numeric } from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import DataTable from '../../../components/Partials/DataTable'
  import axios from 'axios'
  import StoreGroup from './StoreGroup.vue'

  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null
  export default {
    name: 'CategoryForm',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      SelectDropdown,
      cSwitch,
      Multiselect,
      DataTable
    },
    data: function () {
      return {
        totalStoresIncluded: 0,
        allSelected: false,
        uuids: [],
        field: null,
        key: null,
        type: 'like',
        selectedStore: [],
        isLoading: false,
        outlets: [],
        statuses: [],
        item: {
          uuid: '',
          name: {},
          outlet_ids: [],
          active: 1
        },
        filter: {
          options: [],
          selected: null,
          status: 1,
          code: '',
          field: null,
          key: null,
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'code',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'name',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            },
            {
              name: 'area_code',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'jpchar',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'owner_code',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'owner_name',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'address',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            }
          ],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          required
        }
      }
    },
    methods: {
      updateSort: function (field) {
        for (let i in vm.dataTable.fields) {
          if (vm.dataTable.fields[i].name == field && (vm.dataTable.fields[i].sort == null || vm.dataTable.fields[i].sort == false)) {
            return
          }
        }
        if (vm.dataTable.sort.field != field) {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (vm.dataTable.sort.type == 'asc') {
            vm.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            vm.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }
        vm.getOutletList()
      },
      addStoreGroup () {
        // modal, paramsOrProps, params, events = {}
        vm.$modal.show(StoreGroup, 
        { 
          uuid: vm.uuid
        },
        { 
          'class': 'modal-store',
          'height': 'auto',
          'height': 'auto',
          'width': "100%",
          'adaptive': true,
          'scrollable': true
        },
        {
          'closed': (event) => {
            if (vm.$session.exists('outlet_uuids')) {
              vm.uuids = vm.$session.get('outlet_uuids')
              vm.totalStoresIncluded = vm.uuids.length
            }
            vm.getOutletList()
          }
        })
      },
      removeStoreGroup (uuid) {
        // Trigger a confirmation dialog
        let options = {
          okText: vm.$t('common.yes'),
          cancelText: vm.$t('common.no'),
        }
        vm.$dialog.confirm(vm.$t('store_group.delete_confirm'), options)
        .then(function (dialog) {
          let data = {}
          data['outlet_uuids'] = [uuid]
          data['type'] = 'remove'
          vm.axios.outlet.removeStoreFromStoreGroup(vm.uuid, data, respone => {
            vm.totalStoresIncluded -= vm.totalStoresIncluded > 0 ? 1 : 0 
            vm.$toastr.success(vm.$t('message.remove_successful'), vm.$t('message.success'), {})
            vm.getOutletList()
          }, error => {
            console.log('error', error)
          })
        })
        .catch(function () {
        })
      },
      selectAll: function () {
        if (vm.allSelected == true) {
          for (let i in vm.dataTable.items) {
            if (vm.uuids.indexOf(vm.dataTable.items[i].uuid) === -1) {
              vm.uuids.push(vm.dataTable.items[i].uuid)
            }
          }
        } else {
          let uuids = []
          for (let j in vm.uuids) {
            let exist = false
            for (let i in vm.dataTable.items) {
              if (vm.dataTable.items[i].uuid == vm.uuids[j]) {
                exist = true
                break
              }
            }

            if (!exist) {
              uuids.push(vm.uuids[j])
            }
          }
          vm.uuids = vm._.cloneDeep(uuids)
        }
      },
      updateAllSeleted: function () {
        let total = 0
        for (let j in vm.uuids) {
          for (let i in vm.dataTable.items) {
            if (vm.dataTable.items[i].uuid == vm.uuids[j]) {
              total += 1
              break
            }
          }
        }

        if (vm.dataTable.items.length == total) {
          vm.allSelected = true
        } else {
          vm.allSelected = false
        }
      },
      
      loadStoreListFile () {
        let vm = this
        let storeListFileBaseUrl = process.env.store_list_file_url
        let storeListFileUrl = storeListFileBaseUrl + 'Coupon/csv/store/store_group_example.csv'
        if (vm.$session.get('lang') === 'ja') {
          storeListFileUrl = storeListFileBaseUrl + 'Coupon/csv/store/%E5%BA%97%E8%88%97%E3%82%B0%E3%83%AB%E3%83%BC%E3%83%97%E3%81%AE%E4%BE%8B.csv'
        }
        return storeListFileUrl
      },
      clearAll () {
        this.selectedCountries = []
      },
      nameState: function (lang) {
        let currentLang = this.$session.get('lang')
        if (currentLang === lang) {
          if (this.item.name[lang] != undefined && this.item.name[lang] && this.item.name[lang] !== '') {
            return true
          }
          else{
            return false
          }
        } else {
          return true
        }
      },
      checkSubmit: function () {
        let currentLang = this.$session.get('lang')
        if (vm.uuid === 'create' || vm.uuid === undefined) {
          return !this.nameState(currentLang) || vm.uuids.length <= 0
        } else {
          return !this.nameState(currentLang)
        }
      },
      isJSON: function (str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },

      /**
       * upload image then move to next form
       */
      saveStoreGroup () {
        if (vm.uuid === 'create' || vm.uuid === undefined) {
          delete vm.item.uuid
          vm.item.outlet_ids = vm.uuids
          vm.axios.outlet.createStoreGroup(vm.item, respone => {
            if (respone.status === 201) {
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              vm.$router.push({'name': 'store_group_list'})
            }
          }, error => {
            console.log('error', error)
          })
        } else {
          // update store group
          let data = this._.cloneDeep(vm.item)
          delete data.outlet_ids
          vm.axios.outlet.updateStoreGroupDetail(vm.uuid, data, respone => {
            if (respone.status === 200) {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.$router.push({'name': 'store_group_list'})
            }
          }, error => {
            console.log(error)
          })
        }
      },
      getStatusData () {
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          vm.statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ""},
            {text: vm.$t('common.active', langs[l]), value: '1'},
            {text: vm.$t('common.inactive', langs[l]), value: '0'}
          ]
        }
      },
      getOutletList () {
        if (cancel != null) {
          cancel()
        }
        let search = "";
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
            search = "&"+ this.field + "=" + this.key.trim()
        }
        if (String(this.filter.status) != '') {
            search = search + "&active=" + this.filter.status;
        }
        
        let params = ""
        if (vm.uuid === 'create' || vm.uuid === undefined) {
          params += "?limit="+this.dataTable.perPage+"&page=" +this.dataTable.currentPage+"&sort_by="+this.dataTable.sort.field+"&order_by="+this.dataTable.sort.type+ search
        } else {
          params += "?group_uuid="+vm.uuid+"&limit="+this.dataTable.perPage+"&page=" +this.dataTable.currentPage+"&sort_by="+this.dataTable.sort.field+"&order_by="+this.dataTable.sort.type+ search
        }
        vm.axios.outlet.getOutletList(params,{
            cancelToken: new CancelToken(function executor(c) {
              cancel = c
            })
          },  
          function(response){
            vm.dataTable.items = response.data.data.items
            vm.dataTable.total = response.data.data.pagination.total
            vm.updateAllSeleted()
          }
        )
      }
    },
    created: function () {
      this.debouncedInput = _.debounce(this.getOutletList, 240)
      vm = this
      let CancelToken = vm.axios.CancelToken
      this.dataTable.source = CancelToken.source()

      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true) {
          this.filter.options.push(this.dataTable.fields[i])
        }
        if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort == true && this.dataTable.sort.field == null) {
          this.dataTable.sort = {
            field: this.dataTable.fields[i].name,
            type: 'asc'
          }
        }
      }
      vm.getStatusData()
      vm.getOutletList()
    },
    mounted: function () {
      // get store list
      let params = '?limit=10&page=1&sort_by=updated_at&order_by=desc&active=1'
      if (vm.uuid === 'create' || vm.uuid === undefined) {
      }
      else {
        vm.axios.outlet.getStoreGroupDetail(vm.uuid, function (response) {
          if (response.status === 200) {
            vm.item = response.data.data.item
            vm.totalStoresIncluded = response.data.data.item.outlet_ids.length
          }
        }, error => {
          console.log('error', error)
        })
      }
    },
    watch: {
      'filter.key': function (val) {
        this.debouncedInput()
      },
      'dataTable.currentPage': function (val) {
        vm.getOutletList()
      },
      'dataTable.perPage': function (val) {
        vm.getOutletList()
      },
      'filter.status': function (val) {
        vm.getOutletList()
      }
    }
  }
</script>

<style scoped>
  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }
  .store-group-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3e515b;
    text-align: center;
    white-space: nowrap;
    background-color: #f8f9fa;
    border: 1px solid #e4e5e6;
  }
  .custom-checkbox {
    padding-left: 0px;
  }
  .col-6{
    float: left;
  }
  #lunch_txt {
    padding-left: 20px;
  }
  .custom__tag {
    display: inline-block;
    padding: 3px 12px;
    background: #d2d7ff;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 10px;
    cursor: pointer;
  }
  .group_name_input {
    margin-bottom: 5px;
  }
  .storeListTemp {
    float: right;
  }
  .store-group-form .switch.switch-icon{
    margin-top: 5px;
  }
  .store-group-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }
  .store-group-form .header-custom-switch .col-form-label{
    text-align: right;
  }
  .store-group-form .header-custom-switch .uppercase{
    display: inline-flex;
  }
  .close-btn {
    font-size: 18px;
    cursor: pointer;
    float: right;
    line-height: 18px;
    margin-left: 10px;
    color: #0091ff;
  }
  .storeTab {
    border-radius: 17.5px;
    background-color: #e1e6eb;
    padding: 10px 13px 12px 10px;
    position: relative;
    display: inline-block;
    margin-right: 10px;
    color: #000;
    line-height: 1;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .storeGroupLabel {
    margin-top: 15px;
  }

  .pull-right .fa-plus{
    padding-right: 5px;
  }

  #select-dropdown{
    text-align: left;
    padding-left: 0;
  }
</style>
<style>
  .store-group-form #select-dropdown .btn.dropdown-toggle{
    padding: 0 10px !important;
  }

  .store-group-form #select-dropdown{
    float: left;
  }

  .store-group-form .search-form .col-sm-10{
    padding: 0;
    float: right;
  }

  .store-group-form .search-form .col-sm-6{
    padding-left: 0;
    display: inline-flex;
  }

  .border-radius-4px .multiselect__tags{
    border-radius: 4px !important;
  }
  .store-group-form .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
    border-radius: 3px !important;
  }
  .store-group-form .custom-control-label::before {
    border-radius: 3px !important;
  }
  .store-group-form .btn-primary .fa{
    font-size: 20px;
  }
  .store-group-form .btn-primary {
    color: #0091ff;
    background-color: transparent !important;
  }
  .store-group-form .btn-primary:hover{
    color: #0091ff;
    background-color: transparent!important;
  }
  .modal-store{
    z-index: 9999 !important;
  }
  .store-group-form .btn-save {
    float: right;
    margin-right: 22px;
  }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/store_group/BaseForm.vue